<template>
    <div
        class="panel-error"
        data-testid="panel-error"
    >
        <div class="panel-error__message">
            <error-message :icon="errorMessage().icon">
                <template #title>
                    <h1>{{ $t(`${errorMessage().title}`) }}</h1>
                </template>

                <template
                    v-if="errorMessageSubtitle()"
                    #subtitle
                >
                    <p>{{ errorMessageSubtitle() }}</p>
                </template>

                <template #component>
                    <component
                        :is="errorMessageComponent().name"
                        v-bind="errorMessageComponent().props"
                    ></component>
                </template>
            </error-message>
        </div>

        <div class="panel-error__buttons">
            <base-button
                :isType="['simple', 'install']"
                @onClick="tryAgain"
            >
                <template #label>
                    {{$t('twitch.globalMsg.tryAgain')}}
                </template>
            </base-button>
            <base-button @onClick="$router.push({ name: 'VoicesList' })">
                <template #label>
                    {{$t('twitch.globalMsg.cancel')}}
                </template>
            </base-button>
        </div>
    </div>
</template>

<script>
import errorCodes from '@/data/error-codes';
import ErrorMessage from '@Components/ErrorMessage/ErrorMessage';
import ExpirationTime from '@Components/ExpirationTime/ExpirationTime';

export default {
    name: 'PanelError',

    components: {
        BaseButton: () => import (/* webpackChunkName: "BaseButton"*/ '@RepoComponent/BaseButton/BaseButton.vue'),
        ErrorMessage,
        ExpirationTime,
    },

    methods: {
        tryAgain() {
            const { id, price, time } = this.$route.params;

            this.$router.push({
                name: 'PanelLoader',
                params: { id, time, price },
            });
        },

        errorMessage() {
            const { responseStatus } = this.$route.params;
            const responseStatusToString = responseStatus.toString();
            const errorKeys = Object.keys(errorCodes());

            const error = errorKeys.find(error => error === responseStatusToString) ? responseStatusToString : 'common';

            return errorCodes(this)[error];
        },

        errorMessageSubtitle() {
            return this.errorMessage().subtitle ? this.$t(`${this.errorMessage().subtitle}`) : null;
        },

        errorMessageComponent() {
            return this.errorMessage().component ? this.errorMessage().component : false;
        },

        getId() {
            const { id } = this.$route.params;

            return id;
        },

    },
};
</script>

<style src="./PanelError.scss" lang="scss"></style>
